import { render, staticRenderFns } from "./calculate-profit-modal.vue?vue&type=template&id=4bff9bc6&scoped=true&"
import script from "./calculate-profit-modal.vue?vue&type=script&lang=js&"
export * from "./calculate-profit-modal.vue?vue&type=script&lang=js&"
import style0 from "./calculate-profit-modal.vue?vue&type=style&index=0&id=4bff9bc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff9bc6",
  null
  
)

export default component.exports